import React from "react";
import './specification.css';
import LayoutMain from "../../00LayoutMain/LayoutMain";

    function TraderSpecificationSourceGatsby (props) {
        return (
        <LayoutMain title={props.title} description={props.description} lang={props.lang}>
            <main className="TraderSpecification StandartPage">
            <div className="TraderSpecificationIn">
                <iframe src={"https://my.fxbitcoin.org/iframe/info/symbols/?lang="+props.lang} name="info_symbols" title="info_symbols" className="autoHeight-iframe" frameBorder='0' width="100%" height="3000"/>
                {/*<iframe src={"https://my.profiforex.com/iframe/info/symbols/?lang="+props.lang} name="info_symbols" title="info_symbols" className="autoHeight-iframe" frameBorder='0' width="100%" height="3000"/>*/}

                {/*<iframe src={"https://my.rbcforex.org/iframe/info/symbols/?lang="+props.lang} name="info_symbols" title="info_symbols" className="autoHeight-iframe" frameBorder='0' width="100%" height="3000"/>*/}

            </div>
            </main>
        </LayoutMain>

    )}

export default TraderSpecificationSourceGatsby